/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import EditIcon from '@mui/icons-material/Edit';
import { Grid, Tooltip, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Icon from '../../../../../components/Icon';

export const colConfig = ({
  onEdit = () => { },
  onView = () => { }, onSimulate = () => { },
  initAddBonus,
  initRemoveBonus,
  loading,
}) => ({
  sortable: false,
  headerClassName: 'super-app-theme--header',
  headerAlign: 'left',

  cellClassName: () => 'first-column ',
  renderCell: (params) => {
    if (params.field === 'Name') {
      return (
        <Grid
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"

        >
          <Grid item xs={12} onClick={() => onView(params.row?.SID)}>
            <Typography sx={{ cursor: 'pointer' }}>
              {`${params.row.Name} ${params.row.Surname}`}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="caption" style={{ color: '#919191' }}>
              {`${params.row.Username} (${params.row.SID})`}
            </Typography>
          </Grid>
        </Grid>
      );
    }
    if (params.field === 'EnrolledParentID') {
      return (
        <Grid
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item xs={12} onClick={() => onView(params.row?.sponsor?.SID)}>
            <Typography sx={{ cursor: 'pointer' }}>
              {`${params.row?.sponsor?.Name} ${params.row?.sponsor?.Surname}`}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="caption" style={{ color: '#919191' }}>
              {`${params.row?.sponsor?.Username} (${params.row?.sponsor?.SID})`}
            </Typography>
          </Grid>
        </Grid>
      );
    }
    if (params.field === 'actions') {
      const { row } = params;
      const bonusVolume = row?.team1BonusVolume;
      return (
        <div className="flex">
          {/* Edit Icon */}
          <Tooltip placement="top" title="View/Edit">
            <IconButton color="inherit" onClick={() => onEdit(params)}>
              <EditIcon
                style={{ cursor: 'pointer' }}
              />
            </IconButton>
          </Tooltip>

          {/* Simulate Icon */}
          <Tooltip placement="top" title="Simulate">
            <IconButton color="inherit" onClick={() => onSimulate(params.row.id)}>
              <Icon name="Spy" width={24} height={24} />
            </IconButton>
          </Tooltip>
          {/* Add Bonus Icon */}
          {
            params.row.team1BonusVolume === 0 ? (
              <Tooltip placement="top" title="Add bonus volume">
                <IconButton color="inherit" onClick={() => initAddBonus(params.row)} disabled={loading}>
                  <Icon name="MoneyHand" width={24} height={24} />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip placement="top" title={`Remove $${bonusVolume ? bonusVolume.toLocaleString() : 0} bonus volume`}>
                <IconButton color="inherit" onClick={() => initRemoveBonus(params.row)} disabled={loading}>
                  <Icon name="Dollar" width={24} height={24} color="green" />
                </IconButton>
              </Tooltip>
            )
          }
        </div>
      );
    }

    return params;
  },
});

export const defaultFormData = {
  name: '',
};

export const userFormConfig = [
  {
    name: 'myAccountTitle',
    isText: true,
    type: 'h6',
    label: 'Account Data',
  },
  {
    name: 'enrollmentLink',
    type: 'text',
    label: 'Enrollment Link',
  },
  {
    name: 'name',
    type: 'text',
    label: 'Name',
  },
  {
    name: 'surname',
    type: 'text',
    label: 'Surname',
  },
  {
    name: 'username',
    type: 'text',
    label: 'Username',
  },
  {
    name: 'memberID',
    type: 'text',
    label: 'Member ID',
  },
  {
    name: 'enrolledParentId',
    type: 'text',
    label: 'Enrolled Parent ID',
  },
  {
    name: 'serviceLevel',
    type: 'text',
    label: 'Service Level',
  },
  {
    name: 'addressInfoTitle',
    isText: true,
    type: 'h6',
    label: 'Address Info',
  },
  {
    name: 'addressLine1',
    type: 'text',
    label: 'Address Line 1',
  },
  {
    name: 'addressLine2',
    type: 'text',
    label: 'Address Line 2',
  },
  {
    name: 'country',
    type: 'text',
    label: 'Country',
  },
  {
    name: 'city',
    type: 'text',
    label: 'City',
  },
  {
    name: 'state',
    type: 'text',
    label: 'State',
  },
  {
    name: 'zipCode',
    type: 'text',
    label: 'Zip Code',
  },
  {
    name: 'personalInformationTitle',
    isText: true,
    type: 'h6',
    label: 'Personal Information',
  },
  {
    name: 'mobileNo',
    type: 'text',
    label: 'Mobile No',
  },
  {
    name: 'email',
    type: 'text',
    label: 'email',
  },
  {
    name: 'birthday',
    type: 'date',
    label: 'Date Of Birth',
  },
  {
    name: 'title',
    isText: true,
    type: 'h6',
    label: 'Change Password',
  },
  {
    name: 'oldPassword',
    type: 'password',
    label: 'Old Password',
  },
  {
    name: 'newPassword',
    type: 'password',
    label: 'New Password',
  },
  {
    name: 'retypePassword',
    type: 'password',
    label: 'Retype Password',
  },
];

export default {};
